import Vue from 'vue';
import Vuex from 'vuex';

import wechat from './wechat';
import asset from './asset';
import share from './share';
import coach from './coach';
import course from './course';
import trainer from './trainer';
import trainer_apply from './trainer_apply';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        wechat,
        asset,
        share,
        coach,
        course,
        trainer,
        trainer_apply,
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js